import { PlayCircle, UserX, Wrench } from "lucide-react";
import { Reveal, Eyebrow, SectionHeading } from "@/components/Reveal";
import { DemoForm } from "@/components/DemoForm";

const POINTS = [
  { icon: PlayCircle, text: "The prompt library in action — a de-identified encounter becoming a structured note in minutes" },
  { icon: UserX, text: "The de-identification practices that keep PHI out of the workflow entirely" },
  { icon: Wrench, text: "How installation and live training work inside the AI platform your agency already approves" },
];

export function DemoSection() {
  return (
    <section id="demo" className="bg-slate-50 py-20 lg:py-28" aria-labelledby="demo-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <Eyebrow>The Demonstration</Eyebrow>
            <SectionHeading id="demo-heading">Request a Workflow Demonstration</SectionHeading>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              We'll walk your leadership team through the exact VeraChart prompt workflow live over Zoom or Microsoft
              Teams — using the same AI platforms your agency already approves.
            </p>
            <ul className="mt-8 space-y-4">
              {POINTS.map((p) => (
                <li key={p.text} className="flex items-start gap-3.5">
                  <p.icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-600" aria-hidden="true" />
                  <span className="text-sm leading-relaxed text-slate-600">{p.text}</span>
                </li>
              ))}
            </ul>
            <p className="mt-8 rounded-lg border border-slate-200 bg-white p-4 text-xs leading-relaxed text-slate-500">
              Demonstrations use only fictional, de-identified example data — never real client information.
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-xl shadow-navy/5 sm:p-9" data-testid="demo-section-form-card">
              <h3 className="font-display text-xl font-bold tracking-tight text-navy">Request the Demonstration</h3>
              <p className="mb-7 mt-2 text-sm text-slate-500">
                Tell us a little about your organization and we'll follow up shortly.
              </p>
              <DemoForm source="demo-section" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
